<template>
  <div>
    <ul v-if="detail != ''">
      <li>
        <label>合同名称：</label>
        <p>{{ detail.agreement_name }}</p>
      </li>
      <li>
        <label>公司(甲方)名称：</label>
        <p>{{ detail.platform_name }}</p>
      </li>
      <li>
        <label>公司地址：</label>
        <p>{{ detail.platform_address }}</p>
      </li>
      <li>
        <label>合同状态：</label>
        <p v-show="detail.status == 1">需要签署</p>
        <p v-show="detail.status == 2">无需签署</p>
      </li>
      <li>
        <label>状态类型：</label>
        <p v-show="detail.type == 1">入职合同</p>
        <p v-show="detail.type == 2">离职合同</p>
      </li>
      <li>
        <label>工作类型：</label>
        <p v-show="detail.work_contract_type == 1">长期工合同</p>
        <p v-show="detail.work_contract_type == 2">临时工合同</p>
      </li>
      <li>
        <label>工作类型：</label>
        <p v-show="detail.is_guard_download == 1">提供员工下载</p>
        <p v-show="detail.is_guard_download == 2">员工不可下载</p>
      </li>
      <li>
        <label>创建时间：</label>
        <p>{{ detail.create_time }}</p>
      </li>
      <li>
        <label>修改时间：</label>
        <p>{{ detail.update_time }}</p>
      </li>
      <br />
      <li class="imgsStyle">
        <label>合同信息：</label>
        <div>
          <img
            v-for="(item, index) in detail.imgs"
            :src="item"
            :key="index"
            alt=""
          />
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: ""
    };
  },
  props: {
    detailVal: {}
  },
  watch: {
    detailVal() {
      this.getDetail();
    }
  },
  mounted() {
    if (this.detailVal != undefined) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.detail = this.detailVal;
    }
  }
};
</script>
<style lang="less" scoped>
ul {
  margin: 30px 3%;
  li {
    margin-bottom: 10px;
    p,
    label {
      font-size: 14px;
      line-height: 20px;
      display: inline-block;
    }
  }
  .imgsStyle {
    display: block;
    > div {
      border: 1px solid #ccc;
      margin-top: 10px;
      img {
        height: 200px;
        width: 100%;
        object-fit: cover;
        display: block;
      }
    }
  }
}
</style>
